/**
 * Traceability levels a contract can be resolved to, from the most precise
 * (land plot) to the least (village). `color` is consumed by the map layers,
 * `badgeClass` by the legacy `pem-badge` tables, `pillClass` by the `ds-pill`
 * design-system tables and `dotClass` by compact tables with no room for words.
 */
export const TRACEABILITY_TYPES = [
    { label: "Land Plot", value: "landplot", color: "#e65561cc", badgeClass: "pem-badge--land", pillClass: "ds-pill--landplot", dotClass: "ds-trace-dot--landplot" },
    { label: "Pickup Location", value: "pickedupposition", color: "#ffd96677", badgeClass: "pem-badge--pickup", pillClass: "ds-pill--pickedupposition", dotClass: "ds-trace-dot--pickedupposition" },
    { label: "Business Position", value: "businessposition", color: "#4287f577", badgeClass: "pem-badge--business", pillClass: "ds-pill--businessposition", dotClass: "ds-trace-dot--businessposition" },
    { label: "Village", value: "village", color: "#32a89b77", badgeClass: "pem-badge--village", pillClass: "ds-pill--village", dotClass: "ds-trace-dot--village" },
];

export type TraceabilityType = typeof TRACEABILITY_TYPES[number];

export const getTraceabilityData = (label: string): TraceabilityType => {
    const found = TRACEABILITY_TYPES.find(t => t.value === label);
    if (found) return found;
    return {
        label: label,
        value: label,
        color: "grey",
        badgeClass: "pem-badge--business",
        pillClass: "ds-pill--businessposition",
        dotClass: "ds-trace-dot--businessposition",
    };
};

/** Maps the raw `deforestation_label` onto a `ds-pill--risk-*` modifier. */
export const deforestationPillClass = (rawLabel: string | undefined): string => {
    switch (rawLabel) {
        case 'False':
        case 'MSD':
            return 'ds-pill--risk-none';
        case 'True':
        case 'Non-MSD':
            return 'ds-pill--risk-warn';
        default:
            return 'ds-pill--risk-unknown';
    }
};
